import { render, staticRenderFns } from "./AkSkCreate.vue?vue&type=template&id=dab85096"
import script from "./AkSkCreate.vue?vue&type=script&lang=js"
export * from "./AkSkCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports